import React from 'react';
import './ticketStyles.css';

export const TicketVenta = React.forwardRef(({
  carrito,
  totales,
  infoNegocio = {},
  ventaId = "000000",
  numeroFactura,
  fechaVenta,
  cajero,
  clienteNombre,
  clienteDocumento,
  clienteTelefono,
  clienteDireccion,
  metodoPago,
  efectivoRecibido,
  cambioEntregado,
  montoTransferencia
}, ref) => {
  const { subtotal, impuestos, total, totalDescuento } = totales;

  const tipoPapel = infoNegocio.anchoTicket || '57mm';

  let anchoContenedor = '57mm';
  let tamañoFuenteBase = '8.5px';
  let tamañoFuenteTitulo = '12px';
  let tamañoFuentePequena = '7.5px';

  if (tipoPapel === '80mm') {
    anchoContenedor = '76mm';
    tamañoFuenteBase = '10px';
    tamañoFuenteTitulo = '14px';
    tamañoFuentePequena = '8.5px';
  }

  const styles = {
    container: {
      width: anchoContenedor,
      padding: '0mm 2mm 15mm 2mm',
      color: '#000',
      fontFamily: 'Arial, Helvetica, sans-serif',
      fontSize: tamañoFuenteBase,
      lineHeight: '1.2',
      backgroundColor: '#fff',
      textTransform: 'uppercase'
    },
    header: { textAlign: 'center', marginBottom: '8px' },
    logoContainer: { display: 'flex', justifyContent: 'center', marginBottom: '5px' },
    logo: { maxWidth: '35mm', filter: 'grayscale(1)' },
    divider: { borderTop: '1px dashed #000', margin: '5px 0' },
    dividerDotted: { borderTop: '1px dotted #888', margin: '3px 0' },
    textRight: { textAlign: 'right' },
    textCenter: { textAlign: 'center' },
    bold: { fontWeight: 'bold' },
    tituloEmpresa: { fontWeight: '900', fontSize: tamañoFuenteTitulo, marginBottom: '2px' },
    totalRow: { display: 'flex', justifyContent: 'space-between', padding: '2px 0' },
    itemRow: { display: 'flex', justifyContent: 'space-between', fontSize: tamañoFuenteBase, marginTop: '4px', alignItems: 'flex-start' },
    legalText: { fontSize: tamañoFuentePequena, textAlign: 'justify', marginTop: '6px', color: '#333' },
    productName: { fontWeight: 'normal', fontSize: tamañoFuenteBase },
    qrWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '8px', padding: '4px' }
  };

  const numeroMostrar = numeroFactura ? numeroFactura : (ventaId.toString().includes('-') ? ventaId.toString().split('-')[0].toUpperCase() : ventaId);
  const fechaImpresion = fechaVenta ? new Date(fechaVenta) : new Date();

  return (
    <div ref={ref} id='ticket-print-area' style={styles.container}>
      <div style={styles.header}>
        {infoNegocio.logo && (
          <div style={styles.logoContainer}>
            <img src={infoNegocio.logo} style={styles.logo} alt="logo" />
          </div>
        )}
        <div style={{ ...styles.bold, fontSize: tamañoFuenteTitulo, marginBottom: '2px' }}>{infoNegocio.nombre || ''}</div>
        {infoNegocio.nombre_legal && infoNegocio.nombre_legal !== infoNegocio.nombre && (
          <div style={{ fontSize: tamañoFuentePequena, fontWeight: '600' }}>{infoNegocio.nombre_legal}</div>
        )}
        <div style={{ fontWeight: '600' }}>NIT: {infoNegocio.nit || '900.000.000-1'}</div>
        <div style={{ fontWeight: '600' }}>{infoNegocio.direccion || 'Dirección no registrada'}</div>
        <div style={{ fontWeight: '600' }}>TEL: {infoNegocio.telefono || '0000000000'}</div>
      </div>

      <div style={styles.divider} />

      <div style={{ fontSize: tamañoFuenteBase }}>
        <div style={styles.bold}>RECIBO: {numeroMostrar}</div>
        <div style={{ fontWeight: '600' }}>FECHA: {fechaImpresion.toLocaleDateString()} {fechaImpresion.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
        <div style={{ fontWeight: '600' }}>CAJERO: {cajero}</div>
        <div style={{ fontWeight: '600' }}>MEDIO DE PAGO: {metodoPago || 'EFECTIVO'}</div>
      </div>

      <div style={styles.divider} />

      <div style={{ fontSize: tamañoFuenteBase, textAlign: 'left', marginTop: '4px', marginBottom: '4px' }}>
        <div style={styles.bold}>CLIENTE: {clienteNombre || 'CONSUMIDOR FINAL'}</div>
        <div style={{ fontWeight: '600' }}>CC/NIT: {clienteDocumento || '222222222222'}</div>
        {clienteTelefono && <div style={{ fontWeight: '600' }}>TEL: {clienteTelefono}</div>}
        {clienteDireccion && <div style={{ fontWeight: '600' }}>DIR: {clienteDireccion}</div>}
      </div>

      <div style={styles.divider} />

      <div style={{ marginBottom: '4px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: tamañoFuentePequena, fontWeight: '800', borderBottom: '1px solid #000', paddingBottom: '2px', marginBottom: '4px' }}>
          <span style={{ width: '15%' }}>CANT</span>
          <span style={{ width: '40%', textAlign: 'center' }}>V. UNIT</span>
          <span style={{ width: '45%', textAlign: 'right' }}>TOTAL</span>
        </div>

        {carrito.map((item, index) => {
          const cantidad = item.numItems || item.cantidad || 1;
          const precioVenta = item.precioVenta || 0;
          const descuento = Number(item.descuento || 0);
          const precioFinalItem = precioVenta * (1 - descuento / 100);
          const totalItem = precioFinalItem * cantidad;

          return (
            <div key={index} style={{ marginBottom: '4px' }}>
              <div style={{ ...styles.productName, fontWeight: '600' }}>{item.nombre}</div>

              <div style={styles.itemRow}>
                <span style={{ width: '15%', fontWeight: '600' }}>{cantidad}</span>

                <span style={{ width: '40%', textAlign: 'center', fontWeight: '600', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  {descuento > 0 ? (
                    <>
                      <span style={{ color: '#000', lineHeight: '1' }}>
                        ( ${Number(precioVenta).toLocaleString('es-CO')} {descuento > 0 ? ' - ' + descuento.toFixed(1) + '%' : ''} )
                      </span>
                      <span style={{ lineHeight: '1', marginTop: '2px' }}>
                        ${Number(precioFinalItem).toLocaleString('es-CO')}
                      </span>
                    </>
                  ) : (
                    <span>${Number(precioVenta).toLocaleString('es-CO')}</span>
                  )}
                </span>

                <span style={{ ...styles.bold, width: '45%', textAlign: 'right' }}>
                  ${Number(totalItem).toLocaleString('es-CO')}
                </span>
              </div>
              <div style={styles.dividerDotted} />
            </div>
          );
        })}
      </div>

      <div style={{ ...styles.totalRow, fontWeight: '600' }}>
        <span>SUBTOTAL:</span>
        <span>${Number(subtotal || total).toLocaleString('es-CO')}</span>
      </div>

      {impuestos > 0 && (
        <div style={{ ...styles.totalRow, fontWeight: '600' }}>
          <span>IVA/IMPUESTOS:</span>
          <span>${Number(impuestos).toLocaleString('es-CO')}</span>
        </div>
      )}

      {totalDescuento > 0 && (
        <div style={{ ...styles.totalRow, fontWeight: '600' }}>
          <span>DESCUENTO TOTAL:</span>
          <span>-${Number(totalDescuento).toLocaleString('es-CO')}</span>
        </div>
      )}

      <div style={{ ...styles.totalRow, ...styles.bold, fontSize: tamañoFuenteTitulo, marginTop: '6px', marginBottom: '4px', borderTop: '1px solid #000', paddingTop: '4px', fontWeight: '800' }}>
        <span>{metodoPago === 'Credito' ? 'TOTAL FACTURA' : 'TOTAL A PAGAR'}</span>
        <span>${Number(total).toLocaleString('es-CO')}</span>
      </div>

      {metodoPago === 'Efectivo' && (
        <>
          <div style={{ ...styles.totalRow, marginTop: '4px', fontWeight: '600' }}>
            <span style={{ fontWeight: '600' }}>EFECTIVO RECIBIDO:</span>
            <span>${Number(efectivoRecibido || total).toLocaleString('es-CO')}</span>
          </div>
          <div style={{ ...styles.totalRow, fontWeight: '600' }}>
            <span style={{ fontWeight: '600' }}>CAMBIO ENTREGADO:</span>
            <span>${Number(cambioEntregado || 0).toLocaleString('es-CO')}</span>
          </div>
        </>
      )}

      {metodoPago === 'Transferencia' && (
        <div style={{ ...styles.totalRow, marginTop: '4px', fontWeight: '600' }}>
          <span style={{ fontWeight: '600' }}>PAGADO EN TRANSF.:</span>
          <span>${Number(total).toLocaleString('es-CO')}</span>
        </div>
      )}

      {metodoPago === 'Mixto' && (
        <>
          <div style={{ ...styles.totalRow, marginTop: '4px', fontWeight: '600' }}>
            <span style={{ fontWeight: '600' }}>PAGADO EN EFECTIVO:</span>
            <span>${Number(efectivoRecibido || 0).toLocaleString('es-CO')}</span>
          </div>
          <div style={{ ...styles.totalRow, fontWeight: '600' }}>
            <span style={{ fontWeight: '600' }}>PAGADO EN TRANSF.:</span>
            <span>${Number(montoTransferencia || 0).toLocaleString('es-CO')}</span>
          </div>
        </>
      )}

      {metodoPago === 'Credito' && (
        <>
          {Number(efectivoRecibido) > 0 && (
            <>
              <div style={{ ...styles.totalRow, marginTop: '4px', fontWeight: '600' }}>
                <span style={{ fontWeight: '600' }}>Abono Inicial (Efectivo):</span>
                <span>${Number(efectivoRecibido || 0).toLocaleString('es-CO')}</span>
              </div>

              <div style={{ ...styles.totalRow, ...styles.bold, fontSize: tamañoFuenteTitulo }}>
                <span style={{ fontWeight: '600' }}>Saldo Pendiente:</span>
                <span>${Number((total || 0) - (efectivoRecibido || 0)).toLocaleString('es-CO')}</span>
              </div>
            </>
          )}
        </>
      )}

      <div style={styles.divider} />

      <div style={styles.legalText}>
        <p style={{ margin: '0 0 4px 0', ...styles.bold, fontWeight: '900', textAlign: 'center' }}>*** DOCUMENTO EQUIVALENTE POS ***</p>
        <p style={{ margin: '0 0 4px 0', ...styles.bold, fontWeight: '800' }}>ESTE DOCUMENTO NO CONSTITUYE UNA FACTURA ELECTRÓNICA DE VENTA.</p>
        <p style={{ margin: '0 0 4px 0', ...styles.bold, fontWeight: '800' }}>Por favor revise sus artículos. No se aceptan reclamos ni devoluciones después de 3 días calendario.</p>
        <p style={{ margin: '0 0 4px 0', ...styles.bold, borderTop: '1px dotted #888', paddingTop: '4px', fontWeight: '800' }}>
          Estimado cliente, según la ley estatutaria 1581 de 2012 habeas data, que regula los deberes que asisten a los Responsables de tratamiento de datos personales, le informamos que {infoNegocio.nombre_legal} manejará los datos que suministras en nuestras cajas para fines informativos y promocionales de nuestra organización.
        </p>
      </div>

      <div style={{ textAlign: 'center', fontSize: tamañoFuentePequena, marginTop: '8px' }}>
        <p style={{ marginTop: '6px', letterSpacing: '0.5px', ...styles.bold, color: '#000', fontWeight: '600' }}>SISTEMA POS GENERADO POR YUGONUB S.A.S</p>
        <p style={{ marginTop: '6px', letterSpacing: '0.5px', ...styles.bold, color: '#000', fontWeight: '600' }}>SITIO WEB: WWW.POS.YUGONUB.COM</p>
        <p style={{ marginTop: '6px', letterSpacing: '0.5px', ...styles.bold, color: '#000', fontWeight: '600' }}>TELÉFONO: 3147787028</p>
      </div>

      <div style={{ height: '10mm' }}></div>
    </div>
  );
});

TicketVenta.displayName = 'TicketVenta';